export default import.meta.ROLLDOWN_FILE_URL_QW4F9_IOrmUMcXpR7YZvSw